module.exports = __webpack_public_path__ + "media/images/webpage/hotels/9494/plan1-1-64cbf44fed60bd53e6bd71ea3bd31d7a.webp";